


















import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';
import {
    ResponsibleDelete,
    Responsible,
    ResponsibleUpdate,
} from '@/model/Responsible';
import ToastMixin from '@/mixins/ToastMixin';
import { mixins } from 'vue-class-component';
import ToastVariant from '@/model/enums/toast/toast-variant';
import { ApiError } from '@/model/ApiError';
import LocationTopicResoposibleTable from '@/components/master-data/LocationTopicResponsibleTable.vue';

@Component({
    components: {
        LocationTopicResoposibleTable,
    },
    methods: {
        ...mapActions({
            fetchResponsibles: 'responsibleStorage/fetchResponsibles',
            create: 'responsibleStorage/create',
            update: 'responsibleStorage/update',
            delete: 'responsibleStorage/delete',
        }),
    },
    computed: {
        ...mapGetters({
            responsibles: 'responsibleStorage/getResponsibles',
            respError: 'responsibleStorage/getError',
        }),
    },
})
export default class ResponsiblePage extends mixins(ToastMixin) {
    eventId = Number(this.$route.params.id);

    loading = false;

    fetchResponsibles!: (eventId: number) => Promise<void>;

    create!: (request: ResponsibleUpdate) => Promise<void>;

    update!: (request: ResponsibleUpdate) => Promise<void>;

    delete!: (request: ResponsibleDelete) => Promise<void>;

    respError!: ApiError | null;

    mounted(): void {
        this.loading = true;
        this.fetchResponsibles(this.eventId).finally(() => {
            this.loading = false;
        });
    }

    onAdd(request: Responsible | null): void {
        if (!request) {
            return;
        }
        this.create({
            ...request,
            eventId: this.eventId,
        })
            .then(() => {
                this.fetchResponsibles(this.eventId);
                this.showToast(
                    this.$t('responsible.success.event').toString(),
                    this.$t('success-title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.respError) {
                    this.showToast(
                        this.$t(`responsible.${this.respError.key}`).toString(),
                        this.$t('responsible.error-title').toString(),
                        ToastVariant.DANGER,
                    );
                }
            });
    }

    onRemove(responsible: Responsible): void {
        this.delete({ eventId: this.eventId, responsibleId: responsible.id })
            .then(() => {
                this.fetchResponsibles(this.eventId);
                this.showToast(
                    this.$t('responsible.success.delete').toString(),
                    this.$t('success-title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.respError?.key) {
                    if (this.respError?.key === 'has-event-item.responsible') {
                        this.showToast(
                            this.$t(`${this.respError.key}`).toString(),
                            this.$t('responsible.error-title').toString(),
                            ToastVariant.DANGER,
                        );
                    }
                }
            });
    }

    onSaveEdit(request: Responsible): void {
        this.update({ ...request, eventId: this.eventId })
            .then(() => {
                this.fetchResponsibles(this.eventId);
                this.showToast(
                    this.$t('responsible.success.edit').toString(),
                    this.$t('success-title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.respError) {
                    if (this.respError?.key === 'validation.field-invalid') {
                        this.showToast(
                            this.$t(
                                `${this.respError?.validationMessages?.name}`,
                            ).toString(),
                            this.$t('location.toast.edit.title').toString(),
                            ToastVariant.DANGER,
                        );
                    } else {
                        this.showToast(
                            this.$t(
                                `responsible.${this.respError.key}`,
                            ).toString(),
                            this.$t('responsible.error-title').toString(),
                            ToastVariant.DANGER,
                        );
                    }
                }
            });
    }
}
